import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function ProctedRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const { LoginUpdate } = useSelector((state) => state);
  const { InputLimit } = useSelector((state) => state);
  // Get tokken from local storage
  const storedData = localStorage.getItem("conserve_authtoken");
  // const authenticated = localStorage.getItem("Conserve_http_Authenticated");
  const authenticated = true;
  const two_factor_auth = localStorage.getItem("two_factor_auth");
  
  useEffect(() => {
    if (!storedData && two_factor_auth !== "true" && location?.state?.refresh==undefined?true:false) {
      if (authenticated) {
        navigate("/login");
      } else {
        navigate("/");
      }
    }
  }, [LoginUpdate]);
  return <Outlet />;
}

export default ProctedRoute;
